import { RuntimeConfig } from '@vp/common/api';
import { readonly, ref } from 'vue';

const config = ref<RuntimeConfig.RuntimeConfig | null>(null);

export const initRuntimeConfig = async (): Promise<RuntimeConfig.RuntimeConfig> => {
  if (config.value) {
    return config.value;
  }
  config.value = await RuntimeConfig.getRuntimeConfig();
  return config.value;
};

export const useRuntimeConfig = () => {
  if (typeof window !== 'undefined' && !config.value) {
    void initRuntimeConfig();
  }

  return { config: readonly(config) };
};
